/**
 * Company: SPHMedia
 * Description: [useFollowTopicToast custom hook]
 */

import { useEffect, useState } from "react";

type useFollowTopicsToastData = {
  hide: boolean;
  handleClose: () => void;
  showToast: () => void;
};

type useFollowTopicsToastProps = {
  forceShowToast?: boolean;
};

/**
 * Custom React Hook: useFollowTopicToastHook
 * Description: [handles the state and behavior for follow topic toast message]
 * @param props - The props required by the hook (if any)
 * @returns data - The data returned by the hook
 */
export default function useFollowTopicsToast({
  forceShowToast,
}: useFollowTopicsToastProps): useFollowTopicsToastData {
  const [hide, setHide] = useState<boolean>(forceShowToast ? false : true);

  const showToast = () => {
    setHide(false);
  };
  const handleClose = () => {
    setHide(true);
  };

  useEffect(() => {
    if (forceShowToast) {
      setHide(false);
    }
  }, [forceShowToast]);

  useEffect(() => {
    if (!hide) {
      const timer = setTimeout(() => {
        setHide(true);
      }, 2500); // auto-hide after 2.5s
      return () => {
        clearTimeout(timer);
      };
    }
  }, [hide]);

  return { hide, handleClose, showToast };
}
